module.exports = __webpack_public_path__ + "static/media/tablet1.3f6e6db6.svg";